export default "__VITE_ASSET__71c176ed__"